export class UnitConversionDto {
  // After the discussion the 15/06/2022 it was determinated by Ken the amount it will be always as unity (gm/Kl, ml/L, Unit)
  unitValue: number;
  unitName: string;
  costPerUnity: number;
  // Amount after translate to the size
  amount: number;
  // The size of an unit cuantify as amount (used for recipes)
  amountSize?=1;
  unitValueOriginal?:number;
  cost?: number;
}
